import styled from 'styled-components';
import { Card, spaceMixin, token } from '@zillow/constellation';

// style - bones
import 'app/shared/components/Bone/style.scss';

// vars
const photoAddressContainerHeight = '200px';
const addressContainerBoneHeight = '42px';
const propertyCardCTAContainerHeight = '86px';
const panelHeight = '75px';

export const StyledCard = styled(Card)`
    /* override */
    border-bottom: none;
    box-shadow: none;

    border: 1px solid ${token('colors.gray200')};
    padding: ${spaceMixin(2)} ${spaceMixin(2)} 0 ${spaceMixin(2)};
`;

export const StyledPhotoAddressContainer = styled.div`
    height: ${photoAddressContainerHeight};
    margin-bottom: 4px;
`;

export const PropertyStatus = styled.div`
    width: 122px;
    height: 26px;
`;

export const StyledPropertyCardCTAContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: ${propertyCardCTAContainerHeight};
`;

export const StyledAddressContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    height: ${addressContainerBoneHeight};
    margin-right: 10px;
`;
export const StyledLinkElement = styled.div`
    width: 100px;
    height: ${addressContainerBoneHeight};
`;

export const StyledPropertyPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledPropertyPanel = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    height: ${panelHeight};
    margin: 8px 0;
`;
